import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import Modal from "react-responsive-modal";

import noScroll from "no-scroll";

import ReactPopup from "components/popup/ReactPopup";

class MoreButton extends Component {
	static defaultProps = {
		children: () => <span />,
		trigger: null,
		left: null,
		right: null,
		top: null,
		bottom: null,
	};
	constructor(props) {
		super(props);

		this.state = {
			open: false,
			changeDom: null,
			modalStyles: {},
		};
		this.modalRef = React.createRef();
		this.moreLayerRef = React.createRef();
	}

	/**
	 * 버튼 갯수 체크
	 * @param children
	 * @returns {number}
	 */
	getChildrenCount(children) {
		let count = 0;
		React.Children.map(children, (child) => {
			if (child) {
				count++;
			}
		});
		return count;
	}

	/**
	 * fragment 인지 확인
	 * @param children
	 * @returns {boolean}
	 */
	isReactFragment(children) {
		if (children.type) {
			return children.type === React.Fragment;
		}
		return children === React.Fragment;
	}

	handleMenuItemClick = () => {
		this.handleClose();
	};

	handleClose = () => {
		noScroll.off(); //Dom이 먼저사라져서 Modal에 componentWillUnmount를 호출하지 않어 noScroll이 동작하지 않아서 호출함
		this.setState({
			open: false
		});
	};

	/**
	 * Modal를 재사용 (modal dom , modal style)
	 */
	changeContent = (dom, modalStyles = {}) => {
		if (this.modalRef.current) {
			this.modalRef.current.shouldClose = null; //onMouseDown으로 shouldClose=false 가되어 null로 초기화함(두번클릭버그수정)
		}

		this.setState({
			changeDom: dom,
			modalStyles,
		});
	};

	renderTrigger = () => {
		const triggerProps = { key: "T", onClick: this.handleModalOpen };
		const { trigger } = this.props;
		if (typeof trigger === "function") return React.cloneElement(trigger(this.state.open), triggerProps);

		return React.cloneElement(trigger, triggerProps);
	};
	renderPopupTrigger = () => {
		const { trigger } = this.props;
		if (typeof trigger === "function") return React.cloneElement(trigger(this.state.open));
		return React.cloneElement(trigger);
	};

	renderContent = () => {
		return typeof this.props.children === "function"
			? this.props.children({ changeContent: this.changeContent, close: this.handleClose })
			: this.props.children;
	};

	handleModalOpen = (e) => {
		let children = this.renderContent().props ? this.renderContent().props.children : this.renderContent();
		children = children.length ? children : [children];
		const count = children.filter((child) => {
			return child;
		}).length;

		const top = e.clientY - e.nativeEvent.offsetY;
		const menuHeight = count * 40 + 26;

		var right = window.innerWidth - (e.clientX - e.nativeEvent.offsetX + 35) + 10;

		// 가로모드에서 right가 안 맞아서 900px 이상 일때만 right 수정
		if(window.innerWidth > 900){
			right = right - (window.innerWidth * 0.1) - ((window.innerWidth - 1000) / 3);
		}

		var left;

		// window.location.pathname : /wnnw/vods/all or /wnnw/vods : 전체 VOD
		const vodAllPath = String(window.location.pathname).split("/")[4] == "all" || typeof(String(window.location.pathname).split("/")[4]) == "undefined";

		//캐치, 전체vod 탭 left,right 추가
		if((String(window.location.pathname).includes('catch')===true || vodAllPath) && e.clientX < 150){
			left = 0;
			right = 'auto !important'; 
		}

		//화면높이 < dom 위치 + 여백30
		if (window.innerHeight < top + menuHeight + 30) {
			this.setState({
				open: true,
				changeDom: null,
				style: {
					position: "absolute",
					right,
					top: top - menuHeight - 10,
					left : left
				},
			});
		} else {
			this.setState({
				open: true,
				changeDom: null,
				style: {
					position: "absolute",
					right,
					top: top + 20,
					left : left
				},
			});
		}
	};

	handlePopupOpen = () => {
		this.setState({
			open: true,
			changeDom: null,
		});
	};
	handlePopupClose = () => {
		this.setState({
			open: false,
		});
	};

	render() {
		const { changeDom, open, style, modalStyles } = this.state;
		const { left, right, top, bottom } = this.props;

		// 노출될 버튼이 있는지 확인
		let children = this.renderContent();
		if (this.isReactFragment(children)) {
			children = children.props.children;
		}
		const length = this.getChildrenCount(children);

		if (length === 0) {
			return null;
		}

		if (isMobile) {
			return (
				<React.Fragment>
					{this.renderTrigger()}
					<Modal
						ref={this.modalRef}
						closeOnOverlayClick={true}
						open={open}
						onClose={this.handleClose}
						showCloseIcon={false}
						classNames={{
							overlay: "unset_st",
							modal: "modal_modal_style",
						}}
						styles={{overlay : changeDom ? modalStyles : {background: '#0000'}}}
					>
						
						{changeDom ? (
							changeDom
						) : (
							<div ref={this.moreLayerRef} className="more-layer" onClick={this.handleMenuItemClick} style={style}>
								{this.renderContent()}
							</div>
						)}
					</Modal>
				</React.Fragment>
			);
		} else {
			return (
				<ReactPopup open={open} onOpen={this.handlePopupOpen} onClose={this.handlePopupClose} trigger={this.renderPopupTrigger()}>
					{changeDom ? (
						changeDom
					) : (
						<div className="more-layer" style={{ position: "absolute", left, right, top, bottom }}>
							{this.renderContent()}
						</div>
					)}
				</ReactPopup>
			);
		}
	}
}

export default MoreButton;
